import TrendingDownRounded from '@mui/icons-material/TrendingDownRounded';
import TrendingUpRounded from '@mui/icons-material/TrendingUpRounded';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import type { BreakdownTab } from '../data/mediaBreakdownData';

interface TabConfig {
  id: BreakdownTab;
  label: string;
  color: 'success.main' | 'error.main' | 'warning.main';
  icon: ReactNode;
}

const TABS: TabConfig[] = [
  {
    id: 'over',
    label: 'Over Performing',
    color: 'success.main',
    icon: <TrendingUpRounded sx={{ fontSize: 16 }} />,
  },
  {
    id: 'under',
    label: 'Under Performing',
    color: 'error.main',
    icon: <TrendingDownRounded sx={{ fontSize: 16 }} />,
  },
  {
    id: 'fatigue',
    label: 'Media Fatigue',
    color: 'warning.main',
    icon: <WarningAmberRounded sx={{ fontSize: 16 }} />,
  },
];

interface MediaTabsProps {
  active: BreakdownTab;
  onChange: (tab: BreakdownTab) => void;
}

export function MediaTabs({ active, onChange }: MediaTabsProps): ReactNode {
  return (
    <Box sx={{ display: 'flex', gap: 5, borderBottom: '1px solid', borderColor: 'divider', mb: 4 }}>
      {TABS.map((tab) => {
        const selected = active === tab.id;
        return (
          <Box
            key={tab.id}
            component="button"
            data-test={`media-tab-${tab.id}`}
            onClick={() => onChange(tab.id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              pb: 2,
              fontSize: 13,
              fontWeight: 600,
              whiteSpace: 'nowrap',
              color: selected ? tab.color : 'text.secondary',
              borderBottom: '2px solid',
              borderColor: selected ? tab.color : 'transparent',
              mb: '-1px',
            }}
          >
            <Box
              component="span"
              sx={{ display: 'flex', color: selected ? tab.color : 'text.disabled' }}
            >
              {tab.icon}
            </Box>
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
}
